import { useState } from 'react';
import TabSelector from 'modules/common/components/TabSelector';
import SurgicalProvidersContainer from './SurgicalProvidersContainer';
import SurgicalServicesContainer from './SurgicalServicesContainer';
import { PageTabs, PageTabsOptions } from './helper';
import { Container, Wrapper } from './style';

const SurgicalProvidersAndServicesContainerSelectorPage = () => {
  const [selectedTabOption, setSelectedTabOption] = useState(PageTabs.Providers);
  return (
    <Container>
      <Wrapper>
        <TabSelector
          onChange={payload => {
            setSelectedTabOption(payload.value);
          }}
          options={PageTabsOptions}
          value={selectedTabOption}
        />
        {selectedTabOption === PageTabs.Providers && <SurgicalProvidersContainer />}
        {selectedTabOption === PageTabs.Services && <SurgicalServicesContainer />}
      </Wrapper>
    </Container>
  );
};

SurgicalProvidersAndServicesContainerSelectorPage.propTypes = {};

SurgicalProvidersAndServicesContainerSelectorPage.defaultProps = {};

export default SurgicalProvidersAndServicesContainerSelectorPage;
